import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Compass, Home as HomeIcon, Search, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[var(--pf-canvas)] pt-20 pb-32 lg:pb-20 flex items-center">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[var(--pf-accent-soft)] mb-6">
          <Compass className="w-10 h-10 text-[var(--pf-accent)]" />
        </div>

        <p className="text-sm font-semibold tracking-widest text-[var(--pf-accent)] mb-2">
          ERROR 404
        </p>
        <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
          We couldn't find that page
        </h1>
        <p className="text-gray-600 mb-2">
          The page you're looking for doesn't exist or may have moved.
        </p>
        <p className="text-sm text-gray-500 mb-8 break-all">
          <code className="px-2 py-1 rounded bg-gray-100">{location.pathname}</code>
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="pf-btn-primary inline-flex items-center justify-center gap-2">
            <HomeIcon className="w-4 h-4" />
            Back to Home
          </Link>
          <Link to="/search" className="pf-btn-secondary inline-flex items-center justify-center gap-2">
            <Search className="w-4 h-4" />
            Find Caregivers
          </Link>
          <button
            onClick={() => window.history.back()}
            className="pf-btn-secondary inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
